import { definePanel } from '@/app/definePanel';
import { AuditLogIcon } from '@/components/occurra/icons/AuditLogIcon';
import { PanelMode, PanelTheme } from '@/types/panels';

export default definePanel({
    id: 'audit_log',
    title: 'Audit log',
    description: 'Who changed what, and when.',
    icon: AuditLogIcon,
    width: { min: 560, default: 800, max: Infinity, fill: false },
    // Both modes, as the camera view that a record opens beside it. A record that opens any
    // other panel gives the stage to that panel.
    modes: [PanelMode.View, PanelMode.Settings],
    themes: PanelTheme.Any,
    // Who did what is an administrator's question.
    requiresAdmin: true,
    // On the stage, left of the camera. In the rail, the last place below the rule.
    order: 3.4,
    navGroup: PanelMode.Settings,
    navOrder: 3.74,
});
